import { FunctionComponent } from 'react'
import blackWhatsappIcon from 'assets/icons/black-whatsapp.svg'
import {
  SupportContainer,
  SupportIcon,
  SupportLink,
  SupportText,
  SupportTitle,
} from './style'
import { EExternalLinks } from 'types/enums/EExternalLinks'
import { useTranslation } from 'react-i18next'

const Support: FunctionComponent = () => {
  const { t } = useTranslation('', {
    keyPrefix: `components.support`,
  })

  return (
    <SupportContainer className="bold">
      <SupportTitle>{t('title')}</SupportTitle>
      <SupportLink>
        <SupportText onClick={() => window.open(EExternalLinks.HJBC_WHATSAPP)}>
          {t('whatsapp')}
        </SupportText>
        <SupportIcon
          src={blackWhatsappIcon}
          onClick={() => window.open(EExternalLinks.HJBC_WHATSAPP)}
        ></SupportIcon>
      </SupportLink>
    </SupportContainer>
  )
}

export { Support }
